/**
* 头部菜单
*/

<template>
  <el-menu class="el-menu-demo" mode="horizontal" background-color="#334157" style="height: 60px; border-bottom: none;"
    text-color="#fff" active-text-color="#fff">
    <div class="d-flex flex-align-center flex-justify-between" style="height: 100%;">
      <div class="d-flex flex-align-center logo-title">
        <img src="@/assets/img/logo.jpg" alt="" srcset="">
        中国航油集团重庆石油有限公司培训教育系统
      </div>
      <div class="d-flex flex-align-center">
        <!-- 消息通知 -->
        <el-dropdown trigger="click" @command="changeRole">
          <div class="message-dom" v-buttonAuth="'system:messageCenter'">
            <el-badge :value="isReadNum" class="item">
              <i class="el-icon-bell message-icon"></i>
            </el-badge>
          </div>
          <template #dropdown>
            <el-dropdown-menu>
              <div class="message-list">
                <div class="message-title">未读通知</div>

                <div class="message-item" v-for="item in messageList" :key="item.id" @click="goMessageDetails(item)">
                  <el-badge is-dot class="item message-type">{{ item.title }}</el-badge>
                  <div class="message-content">{{ item.content }}</div>
                  <div class="message-time">{{ item.createTime }} </div>
                </div>
                <div class="message-more" @click="goMessageCenter()">查看更多...</div>

              </div>
            </el-dropdown-menu>
          </template>

        </el-dropdown>
        <!-- 当前身份 -->
        <el-dropdown trigger="click" @command="changeRole">
          <div class="d-flex flex-align-center">
            <div class="col-fff fz14">当前身份：</div>
            <div class="cs-pit d-flex flex-align-center">
              <span class="col-fff fz14">{{ currentRoleItem.roleName || '' }}</span>
              <i class="el-icon-arrow-down fz-18 col-fff"></i>
            </div>
          </div>

          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item v-for="(item, index) in roleList" :key="index" :command="item">{{ item.roleName
                }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>

        </el-dropdown>
        <div style="height: 100%;
    margin: 0 10px;
    border-left: 1px solid white;"></div>
        <el-submenu index="2" class="submenu">

          <template slot="title">
            <img class="avatar" :src="avatar" v-if="avatar" />
            <img class="avatar" v-else />
            {{ user.userName }}</template>
          <el-menu-item @click="goBoard()" v-if="showBtn('system:messageBoard')" index="2-4">留言板</el-menu-item>
          <el-menu-item @click="goCenter()" v-if="showBtn('system:personalCenter')" index="2-1">个人中心</el-menu-item>
          <el-menu-item @click="showDialog()" index="2-2">修改密码</el-menu-item>
          <el-menu-item @click="exit()" index="2-3">退出</el-menu-item>
        </el-submenu>
        <!-- <div @click="exit()" class="col-fff fz14 cs-pit logout-btn">退出</div> -->
      </div>
    </div>
    <el-dialog title="修改密码" :visible.sync="editFormVisible" :close-on-click-modal="false" custom-class="form-dialog"
      width="70%" @close='closeDialog()'>
      <my-form :form-config="formConfig.formItems" ref="editForm" :formRules="formConfig.formRules" @submit="submitForm"
        :dataForm="formConfig.dataForm">
      </my-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='editFormVisible = false'>取消</el-button>
        <el-button size="small" type="primary" class="title" @click="submitForm('editForm')">保存</el-button>
      </div>
    </el-dialog>
    <!-- <WebSocket @message-received="handleMessageReceived"></WebSocket> -->

  </el-menu>
</template>

<script>
import { loginout } from '../api/userMG'
import store from "@/vuex/store";
import { roleMenuSelectTree, roleMenuSelectList } from '@/api/roleMG.js'
import { messagePage } from '@/api/message.js'
import myForm from '@/components/myForm.vue';
import { userEditPsw } from '../api/userMG'
import WebSocketClient from "@/utils/WebSocket.js";
export default {
  components: {
    myForm,
  },
  name: 'navcon',
  computed: {
    isEdit () {
      return this.$store.state.userInfo;　　//需要监听的数据
    },
    isReadNum () {
      return this.$store.state.isReadNum;
    },
    messageList () {
      return this.$store.state.messageList;
    },

  },
  watch: {
    isEdit (newVal, oldVal) {
      this.avatar = this.$store.state.userInfo.avatar || '';
    },
  },
  data () {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else {
        if (this.formConfig.dataForm.checkPass !== '') {
          this.$refs.editForm.$refs.form.validateField('checkPass');
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.formConfig.dataForm.newPassword) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    return {

      editFormVisible: false,
      collapsed: true,
      imgshow: require('../assets/img/show.png'),
      imgsq: require('../assets/img/sq.png'),
      user: {},
      roleList: store.state.userInfo.roleList || [],
      currentRoleItem: store.state.currentRoleItem,
      avatar: store.state.userInfo.avatar || '',
      formConfig: {
        formItems: [
          {
            type: 'input', prop: 'oldPassword', label: '旧密码', property: {
              type: 'password'
            }
          },
          {
            type: 'input', prop: 'newPassword', label: '新密码', property: {
              type: 'password'
            }
          },
          {
            type: 'input', prop: 'checkPass', label: '确认新密码', property: {
              type: 'password'
            }
          },
          // Add more form items as needed
        ],
        formRules: {
          oldPassword: [
            { required: true, message: '请输入旧密码', trigger: 'blur' },
          ],
          newPassword: [
            { required: true, validator: validatePass, trigger: 'blur', }
          ],
          checkPass: [
            { required: true, validator: validatePass2, trigger: 'blur' }
          ],
        },
        dataForm: {
          oldPassword: '',
          newPassword: '',
          checkPass: '',
        },

      },

    }
  },
  // 创建完毕状态(里面是操作)
  created () {
    this.user = store.state.userInfo;
    this.$store.commit('getMessageIsReadNum');
  },
  mounted () {
    this.$store.state.websocketClient = new WebSocketClient();
    this.$store.state.websocketClient.connect(process.env.NODE_ENV === 'production' ? window.location.host : '172.168.9.26');
    this.$store.state.websocketClient.setMessageReceivedCallback(this.handleMessageReceived);

  },
  methods: {
    showBtn (val) {
      return store.state.registerButtonList.map(e => e.permissionFlag).includes(val)
    },

    async changeRole (data) {
      store.state.currentRoleItem = data;
      this.currentRoleItem = data;
      this.setMenuList()
      this.getButtonList(data)
    },
    async setMenuList () {
      const res = await roleMenuSelectTree(store.state.currentRoleItem.roleId);
      store.commit('setMenuList', []);
      store.commit('setMenuList', res.data);

    },
    async getButtonList () {
      const buttonList = await roleMenuSelectList(store.state.currentRoleItem.roleId);
      store.commit('setButtonList', buttonList.data || []);
      setTimeout(() => {
        this.$router.push({ path: '/home' });
        this.$forceUpdate()
      });
    },
    // 退出登录
    exit () {
      this.$confirm('退出登录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {

          loginout()
            .then(res => {
              if (res.code == 200) {
                //如果请求成功就让他2秒跳转路由
                setTimeout(() => {
                  this.$store.commit('logout', 'false')
                  this.$router.push({ path: '/login' })
                  this.$message({
                    type: 'success',
                    message: '已退出登录!'
                  })
                }, 500)
              } else {
                this.$message.error(res.msg)
                this.logining = false
                return false
              }
            })
            .catch(err => {
              // 获取图形验证码
              this.logining = false
              this.$message.error('退出失败，请稍后再试！')
            })
        })
        .catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: '已取消'
          // })
        })
    },
    // 切换显示
    toggle (showtype) {
      this.collapsed = !showtype
      this.$root.Bus.$emit('toggle', this.collapsed)
    },

    showDialog () {
      this.editFormVisible = true;
    },

    closeDialog (dialog) {
      this.formConfig.dataForm = {
        newPassword: '',
        oldPassword: '',
        checkPass: '',
      }
      this.$refs.editForm.$refs.form.resetFields();
      this.$forceUpdate()
      this.editFormVisible = false;
    },
    async submitForm (editData) {
      const data = this.formConfig.dataForm;
      this.$refs.editForm.$refs.form.validate(async valid => {
        if (valid) {
          // 请求方法
          const res = await userEditPsw({ newPassword: data.newPassword, oldPassword: data.oldPassword })
          this.closeDialog();
          this.$message.success('修改密码成功！请重新登录');
          setTimeout(() => {
            this.$store.commit('logout', 'false')
            this.$router.push({ path: '/login' })
            this.$message({
              type: 'success',
              message: '已退出登录!'
            });
          }, 1000)
        } else {
          return false
        }
      })
    },
    goCenter () {
      this.$router.push({ path: '/system/personalCenter' });
    },
    goBoard () {
      this.$router.push({ path: '/message/board' });
    },
    handleMessageReceived (message) {
      if (message.type == 'sys_msg_notice') {
        this.$notify({
          title: message.message.title,
          message: message.message.content,
          duration: 2000
        });
        if (store.state.messageList.length >= 2) {
          store.state.messageList.pop();
          store.state.messageList.unshift(message.message);
        } else {
          store.state.messageList.unshift(message.message);

        }
        store.state.isReadNum++;
      }
    },
    goMessageCenter () {
      this.$router.push({ path: '/message/messageCenter' });
    },
    goMessageDetails (item) {
      this.$router.push({
        path: '/message/messageDetails',
        query: {
          id: item.id
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.el-menu-vertical-demo:not(.el-menu--collapse) {
  border: none;
}

.submenu {
  float: right;
}

.buttonimg {
  height: 60px;
  background-color: transparent;
  border: none;
}

.showimg {
  width: 26px;
  height: 26px;
  position: absolute;
  top: 17px;
  left: 17px;
}

.showimg:active {
  border: none;
}

.w-100 {
  width: 100%;
}

.logout-btn {
  padding: 20px;
  margin-left: 10px;

  &:hover {
    background: rgba(255, 255, 255, 0.065);
  }
}

.avatar {
  width: 47px;
  height: 47px;
  border-radius: 50%;
  background: white;
  margin-right: 15px;
}

.message-dom {
  margin: 0 20px;
  cursor: pointer;

  .message-icon {
    color: white;
    font-size: 25px;
  }
}

.message-list {
  max-width: 300px;
  padding: 10px 25px;

  .message-title {
    font-size: 26px;
    color: #0000FF;
    text-align: center;
    padding-bottom: 15px;
  }

  .message-item {
    padding-bottom: 18px;
    cursor: pointer;
    border-bottom: 1px solid #a0a0a0;
    margin-bottom: 20px;

    &:last-child {
      border-bottom: none
    }

    .message-type {
      font-size: 22px;
    }

    .message-content {
      font-size: 17px;
      padding: 15px;
      padding-left: 15px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

    }

    .message-time {
      font-size: 18px;
      padding-left: 15px;
    }
  }

  .message-more {
    font-size: 24px;
    cursor: pointer;
    color: #0000FF;
    text-align: center;
  }
}

.logo-title {
  padding-left: 40px;

  img {
    width: 48px;
    height: 48px;
    margin-right: 20px;
  }

  font-weight: bolder;
  font-size: 28px;
  color: white;

}
</style>



// WEBPACK FOOTER //
// src/components/navcon.vue